import { render } from "./SiteIcon.vue?vue&type=template&id=81d93788&scoped=true"
import script from "./SiteIcon.vue?vue&type=script&lang=js"
export * from "./SiteIcon.vue?vue&type=script&lang=js"

import "./SiteIcon.vue?vue&type=style&index=0&id=81d93788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d93788"]])

export default __exports__